<template>
  <div class="home-page">
    <!--  贝壳隐私保护理念 start -->
    <Privacy-protect-concept :src="dataList[1]"></Privacy-protect-concept>
    <!--  贝壳隐私保护理念 end -->
    <Principle :data="dataList[2]"></Principle>
    <PrincipleItem
      :data="dataList[3]"
      :style="`background:url(${dataList[3].bgImage})`"
    ></PrincipleItem>
    <PrincipleItem
      :data="dataList[4]"
      :style="`background:url(${dataList[4].bgImage})`"
    ></PrincipleItem>
    <PrincipleItem
      :data="dataList[5]"
      :style="`background:url(${dataList[5].bgImage})`"
    ></PrincipleItem>
    <!--  隐私保护咨询 start -->
    <Consult-service></Consult-service>
    <!--  隐私保护咨询 end-->
  </div>
</template>

<script>
import PrivacyProtectConcept from "../HomePage/PrivacyProtectConcept.vue";
import ProtectPrinciple from "../HomePage/ProtectPrinciple.vue";
import ProductPrivacy from "../HomePage/ProductPrivacy.vue";
import ProtectMeasures from "../HomePage/ProtectMeasures.vue";
import ProtectPolicyHome from "../HomePage/ProtectPolicyHome.vue";
import CertificatAuthority from "../HomePage/CertificatAuthority.vue";
import ConsultService from "../HomePage/ConsultService.vue";
import TheImage from "@/components/The/TheImage.vue";
import PrincipleItem from "@/components/homePage/PrincipleItem.vue";
import Principle from "@/components/homePage/Principle.vue";
export default {
  // 首页入口
  name: "homePage-index",
  components: {
    PrivacyProtectConcept,
    ProtectPrinciple,
    ProductPrivacy,
    ProtectMeasures,
    ProtectPolicyHome,
    CertificatAuthority,
    ConsultService,
    TheImage,
    Principle,
  },
  data() {
    return {
      i: 1,
      beforeI: 0,
      list: 7,
      dataList: [
        {
          id: 1,
          is: TheImage,
          path: "/home-page",
          icon: "",
          link: "",
          bannerImgVideo: 1,
          key: "home-page",
          title: "放心选择 全面守护",
          tips: "全方位保障您的数据安全与个人隐私",
          content:
            "作为科技驱动的新居住服务商，贝壳致力于推进居住服务产业数字化和智能化进程。贝壳高度重视数据安全合规，持续的研发投入与科技创新为居住产业数据安全与用户隐私保驾护航，为三亿中国家庭提供安全、高质、高效的居住服务，以打造“对消费者好、帮助服务者对消费者好”的新居住平台。",
        },
        {
          id: 2,
          is: PrivacyProtectConcept,
          video: "",
          poster: "",
        },
        {
          id: 3,
          title: "原则一：合法合规",
          content: "贝壳依法承担企业主体责任，严守隐私安全红线，守护用户权益。",
          icon: require("@/assets/images/homePage/legal-compliance.gif"),
          bgImage: require("@/assets/images/bj-01.png"),
          key: "customer",
          is: Principle,
        },
        {
          id: 4,
          title: "原则二：最小必要",
          content:
            "贝壳始终遵循数据最小化原则，仅收集与提供相关服务所必须的最小数据量，每个数据处理行为均以特定处理目的为前提，以合法必要为准绳。",
          icon: require("@/assets/images/homePage/minimum-necessary.gif"),
          bgImage: require("@/assets/images/bj-02.png"),
          className: "custom-class",
          key: "small",
          is: isMobile ? PrincipleItem : Principle,
        },
        {
          id: 5,
          title: "原则三：公开透明",
          content:
            "贝壳确保用户可随时随地了解、访问和控制其授权贝壳处理的个人信息，支持用户通过简便易行的方式自主管控个人信息使用权限。",
          icon: require("@/assets/images/homePage/open-and-transparent.gif"),
          bgImage: require("@/assets/images/bj-03.png"),
          key: "transparent",
          is: isMobile ? PrincipleItem : Principle,
        },
        {
          id: 6,
          title: "原则四：安全可靠",
          content: "贝壳拥有高水准的大数据系统及信息安全防护机制，保证您的数据安全。",
          icon: require("@/assets/images/homePage/safe-and-reliable.gif"),
          bgImage: require("@/assets/images/bj-04.png"),
          className: "custom-class",
          key: "safe",
          is: isMobile ? PrincipleItem : Principle,
        },
        {
          id: 7,
          is: ConsultService,
        },
      ],
    };
  },
  async created() {
    this.readDictByKey("banner", (res) => {
      this.dataList[0].bannerImgVideo =
        res.list.map.index.bannerImgVideo === null
          ? 2
          : res.list.map.index.bannerImgVideo;
      this.dataList[0].icon =
        this.dataList[0].bannerImgVideo == 1
          ? res.list.map.index.pic
            ? res.list.map.index.pic
            : require("@/assets/images/swiper-home.jpg")
          : res.list.map.index.videoUrl
          ? res.list.map.index.videoUrl
          : "https://devlawtrust-1306822285.cos.ap-beijing.myqcloud.com/banner/waterfall0525fps.mp4";
      this.dataList[0].link = res.list.map.index.link;
    });
    this.readDictByKey("video", (res) => {
      this.dataList[1].video =
        (isMobile
          ? res.list.map.privacyIdea.videoMobile
          : res.list.map.privacyIdea.video) ||
        "https://devlawtrust-1306822285.cos.ap-beijing.myqcloud.com/video/beike_privacy.mp4";
      this.dataList[1].poster =
        res.list.map.privacyIdea.thumbnail ||
        "https://devlawtrust-1306822285.cos.ap-beijing.myqcloud.com/resource-config/thumbnail.png";
    });
  },
  methods: {
    changeI(i) {
      this.beforeI = this.i;
      setTimeout(() => {
        this.i = i;
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .animate__animated {
  animation-duration: 1.5s;
  animation-duration: 1.5s; // 动画执行时间
  animation-fill-mode: both;
  animation-fill-mode: both;
}

.privacy-protect-concept-main {
  padding: 60px 0;
  height: auto !important;
}

.principle-main {
  padding: 60px 0;
  height: auto !important;
}

.principle-item-main {
  padding: 40px 0;
}

.Consult-service-main {
  padding: 60px 0;
  height: auto !important;
}

.home-page {
  // height: 100%;
}

.last-height {
  height: calc(100% - $multiple * 134px);
}

.other-height {
  height: 100%;
}
</style>
